import FieldRow from 'components/FormElements/FieldRow';
import Spacing from 'components/Spacing';
import { styled } from '@mui/material/styles';
import { sanitiseHtml, dateToLabel } from 'further-ui/utils';

type Props = {
  statementDate?: Date;
  title: string;
  summary: string;
  letter: string;
  accountManager?: string;
  role?: string;
  notes?: string;
  supportingFiles?: Array<{
    name: string;
    path: string;
    preview?: string;
  }>;
};

const StyledSupportingFileLink = styled('a')(({ theme }) => ({
  fontSize: theme.fontSizes?.sm,
  color: theme.palette.text.primary,

  '&:hover': {
    color: theme.palette.text.rootColor,
  },
}));

const Summary = ({
  statementDate,
  title,
  summary,
  letter,
  accountManager,
  role,
  notes,
  supportingFiles,
}: Props) => {
  return (
    <Spacing>
      {statementDate && (
        <FieldRow title="Statement date" centerTitle>
          {dateToLabel(statementDate)}
        </FieldRow>
      )}
      <FieldRow title="Statement title" centerTitle>
        {title || '-'}
      </FieldRow>
      <FieldRow title="Statement summary" centerTitle>
        {summary}
      </FieldRow>
      <FieldRow title="Manager's letter" topTitle>
        <div
          className="text-editor"
          dangerouslySetInnerHTML={{
            __html: sanitiseHtml(letter) ?? '',
          }}
        />
      </FieldRow>
      {accountManager && (
        <FieldRow title="Manager" centerTitle>
          {accountManager}
        </FieldRow>
      )}
      {role && (
        <FieldRow title="Manager's role" centerTitle>
          {role}
        </FieldRow>
      )}
      {notes && (
        <FieldRow title="Notes" topTitle>
          <div
            className="text-editor"
            dangerouslySetInnerHTML={{
              __html: sanitiseHtml(notes) ?? '',
            }}
          />
        </FieldRow>
      )}
      {supportingFiles && supportingFiles.length > 0 && (
        <FieldRow title="Supporting files" centerTitle>
          <div>
            {supportingFiles.map((file, index) => (
              <div key={index}>
                <StyledSupportingFileLink
                  href={file?.preview || file?.path}
                  rel="noreferrer"
                  target={'_blank'}
                >
                  {file?.name || 'Supporting file'}
                </StyledSupportingFileLink>
              </div>
            ))}
          </div>
        </FieldRow>
      )}
    </Spacing>
  );
};

export default Summary;
